import { 
        GTIWebButton, GTIWebAlert,
        Dialog, Typography, Grid, Box, Stack, 
        DoNotDisturbAlt, ArrowBack, CircularProgress
} from "@gti-controls-v2/web-core";
import homePageStyles from "../../common/styles/HomePage";

const ModalTicket = ({
	open,
	type,
	size,
	title,
	cancelText,
	confirmText,
	confirmationInfo,
	isLoading,
	error,
	submitButtonText,
    disabledSubmitButton,
    onSubmit,
	onClose,
    onBack,
    currentStep,
	...props
}) => {
    const styles = homePageStyles;

    const handleConfirm = async () => {
        if (onSubmit) {await onSubmit();} 
		else if (onClose) { await onClose(true); }
	};

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => { if (reason !== 'backdropClick') { onClose(false); } }}
        >
            <Box sx={homePageStyles.modal}>
                <Grid container justify="flex-end">
                    <Grid item xs={12}>
                        <Box sx={styles.modalHeader}>
                            <Box sx={styles.modalHeaderText}>
                                 
                                <Typography variant="h6" sx={styles.modalTitle}>
                                    {type === 'step' && currentStep > 0 ? <GTIWebButton 
                                        id="celularStatus"
                                        icon={<ArrowBack/>}
                                        iconPosition="start"
                                        onlyIcon={true}
                                        tooltipText="Regresar"
                                        onClick={(e) => { if (onBack) { onBack()}}}
                                    /> : null}
                                    {title}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ pb: 4 }}>
                            <Typography variant="body2">
                                {props.children}
                            </Typography>
                        </Box>
                    </Grid>
                    {error ?
						<Grid item xs={12} paddingBottom={4}>
                            <GTIWebAlert
                                icon={<DoNotDisturbAlt />}
                                severity="error"
                                text={error.message}
                            />
						</Grid>
						: null}
                    <Grid item xs={12}>
                        <Box sx={styles.modalButtons}>
                            {
                                type === 'step' ? <Stack direction="row">

                                    <GTIWebButton
                                            sx={styles.modalActionButton}
                                            text={submitButtonText ? submitButtonText :"Siguiente"}
                                            icon={isLoading && <CircularProgress size={30} />}
                                            width={"100%"}
                                            onClick={type === 'info' ? onClose : handleConfirm}
                                            disabled={disabledSubmitButton || isLoading}
                                        />
 
                                     <GTIWebButton
                                        sx={styles.modalActionButton}
                                        text={"Cancelar"}
                                        width={"100%"}
                                        onClick={() => { onClose(false); }}
                                        variant={"outlined"}
                                    />

                                </Stack>  :   
                                <Stack width="100%" direction="row">
                                    <GTIWebButton
                                        sx={styles.modalActionButton}
                                        text={"Cancelar"}
                                        width={"100%"}
                                        onClick={() => { onClose(false); }}
                                        variant={"outlined"}
                                    />
                                    {
                                        type === 'info' ? <></> :
                                        <GTIWebButton
                                            sx={styles.modalActionButton}
                                            text={submitButtonText ? submitButtonText :"Guardar"}
                                            width={"100%"}
                                            onClick={type === 'info' ? onClose : handleConfirm}
                                            disabled={isLoading}
                                        />
                                    }
                                </Stack>
                            }
                          
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Dialog>
    );
};

export default ModalTicket;